import { Input, InputProps } from "./Input";

export function Textarea(props: Readonly<InputProps>) {
    return <Input {...props} as="textarea" />;
}
